interface TableSkeletonProps {
  cols: number;
  rows: number;
}

const TableSkeleton = ({ cols, rows }: TableSkeletonProps) => (
  <tbody>
    {Array.from(Array(rows).keys()).map((row: number) => (
      <tr key={row}>
        {Array.from(Array(cols).keys()).map((col: number) => (
          <td className="loading" key={col}>
            <div className="bar" aria-label="Loading" />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);

export default TableSkeleton;
